import { i18n } from "../translate/i18n";
import { chaveDeErro } from "./chaveDeErro";

// Erro que chega cru na tela (falha de envio, `lastError` de status e
// campanha). Código com tradução vira a frase dela. Sem tradução, sobra a
// mensagem como veio — e "ERR_WAHA: sessão parada" tem a metade legível depois
// do ":", mas o prefixo entrega o fornecedor, que o cliente não vê
// (`helpers/nomeDaApi.js`).
const PREFIXOS = [
	[/\bERR_WAHA\s*:\s*/g, "WhatsApp v2: "],
	[/\bERR_UAZAPI\s*:\s*/g, "WhatsApp v3: "],
	// Erro da Graph API (WhatsApp oficial, Instagram, Messenger). O backend já
	// manda em português os códigos que conhece (`helpers/ErrosDaMeta.ts`).
	[/\bERR_META\s*:\s*/g, "Meta: "],
];

export const textoDeErro = (bruto) => {
	const chave = chaveDeErro(bruto, (nome) =>
		i18n.exists(`backendErrors.${nome}`)
	);

	if (chave) {
		return i18n.t(`backendErrors.${chave}`, {
			interpolation: { escapeValue: false },
		});
	}

	return PREFIXOS.reduce(
		(texto, [padrao, troca]) => texto.replace(padrao, troca),
		String(bruto || "")
	);
};

export default textoDeErro;
